<template>
  <!--
    Dropdown button that confirms an action before calling it
    Emits 'confirmed' event when the confirmed button is clicked
  -->
  <b-dropdown :disabled="disabled" :dropup="dropup" :text="buttonText" :variant="buttonType" :right="right" :size="size">
    <b-dropdown-item @click="$emit('confirmed')" >&nbsp;{{confirmText}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
  import { BDropdown, BDropdownItem } from 'bootstrap-vue'

  export default {
    props: {
      buttonText: {
        type: String,
        required: true
      },
      confirmText: {
        type: String,
        required: true
      },
      buttonType: {
        type: String,
        required: false,
        default: 'default'
      },
      dropup: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      right: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        required: false,
        default: 'md'
      }
    },

    computed: {
      dropClass () {
        return this.dropup ? 'dropup' : 'dropdown'
      }
    },

    components: {
      BDropdown,
      BDropdownItem,
    }
  }
</script>



// WEBPACK FOOTER //
// ConfirmButton.vue?09e39d04